import { useContext } from 'react'

import { FrameBuilderSelectionContext } from '../../contexts/selection-context'
import { FrameBuilderStringsContext } from '../../contexts/strings-context'
import { FrameBuilderValidationContext } from '../../contexts/validation-context'

import ConfigurationStepPreview, {
  type StepPreviewProps,
} from './configuration-step-preview'

const ExtrasStepPreview = ({ number, onClick }: StepPreviewProps) => {
  const frameBuilderStrings = useContext(FrameBuilderStringsContext)
  const { committedStateSelectionMessages } = useContext(
    FrameBuilderSelectionContext,
  )
  const { stepPreviewAnimation } = useContext(FrameBuilderValidationContext)

  return (
    <ConfigurationStepPreview
      step="extras"
      title={frameBuilderStrings.extrasStepTitle}
      value={committedStateSelectionMessages?.extras}
      placeholder={frameBuilderStrings.extrasPlaceholder}
      opacity={stepPreviewAnimation.extrasOpacity}
      number={number}
      onClick={onClick}
      className="grow-0 shrink-0"
    />
  )
}

export default ExtrasStepPreview
